import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import { purple } from '@mui/material/colors'
import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { ReactComponent as VacationIcon } from 'assets/services/hold/VacationIcon.svg'
import { ReactComponent as HoldIcon } from 'assets/work-orders/HoldIcon.svg'
import { HOLD_TYPES } from 'settings/constants/service'

import type { ChipProps } from '@mui/material/Chip'
import type { VacationHoldTypeApi } from 'types/api/account/vacationHold'

type Props = Omit<ChipProps, 'label' | 'type'> & {
  type?: VacationHoldTypeApi | null
  label?: string | null
  isOpen?: boolean
}

const CHIP_SX = {
  fontWeight: 600,
  border: '1px solid',
  borderColor: purple[300],
  backgroundColor: purple[50],
  color: purple[500],
  '& .MuiChip-deleteIcon': { color: purple[300] },
}
const AVATAR_SX = { backgroundColor: purple[300], '& svg': { width: '14px' } }

const VacationHoldChip: React.FC<Props> = ({ type = HOLD_TYPES.VACATION, label, size = 'small', clickable, isOpen, ...rest }) => {
  const showExpandIcon = clickable && typeof isOpen === 'boolean'
  const ExpandIcon = isOpen ? ExpandLess : ExpandMore

  return (
    <Chip
      avatar={
        <Avatar sx={AVATAR_SX}>
          <SvgIcon sx={{ color: 'common.white' }}>{type === HOLD_TYPES.HOLD ? <HoldIcon /> : <VacationIcon />}</SvgIcon>
        </Avatar>
      }
      clickable={clickable}
      deleteIcon={showExpandIcon ? <ExpandIcon /> : undefined}
      label={label || 'Vacation hold'}
      size={size}
      sx={CHIP_SX}
      variant="outlined"
      onDelete={showExpandIcon ? rest.onClick : undefined}
      {...rest}
    />
  )
}

export default VacationHoldChip
